import axios from 'axios';
const token = localStorage.getItem('user-token');
export const endpoints = {
  POLICY: 'admin/configs/policy/status',
  INSURED: 'admin/configs/insured/status',
  PROPOSAL: 'admin/configs/proposal/status',
  PLATE: 'admin/configs/plate/status',
};

export default {
  async update(endpoint, payload) {
    try {
      const response = await axios.patch(
        `${process.env.VUE_APP_API_VIDA_URL}/${endpoint}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },

  async getOptions(endpoint) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/${endpoint}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },

}
